module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-allorderbill"
  }, [_c('navbar', {
    attrs: {
      "title": "货品汇总-餐企"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "goods-company-summary-edit",
    on: {
      "click": _vm.summaryFilter
    }
  }, [_vm._v("筛选")]), _vm._v(" "), (!_vm.midware) ? _c('excel-export', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodsTotalInfo.select_detail == 0),
      expression: "goodsTotalInfo.select_detail==0"
    }],
    on: {
      "excelExport": _vm.sendExcel
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodsTotalInfo.select_detail == 1),
      expression: "goodsTotalInfo.select_detail==1"
    }],
    staticClass: "goods-company-summary-excel imp_btn",
    on: {
      "click": function($event) {
        return _vm.sendExcelSd()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll",
    staticStyle: {
      "bottom": "42px"
    },
    attrs: {
      "id": "common-scroll"
    },
    on: {
      "scroll": _vm.refresh
    }
  }, [(!_vm.midware) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "goods-company-summary-base"
  }, [_c('div', {
    staticClass: "goods-company-summary-left"
  }, [_c('div', [_c('span', [_c('i', {
    staticClass: "goods-company-ico"
  }), _c('strong', {
    staticClass: "goods-company-name"
  }, [_vm._v(_vm._s(_vm.store.goodsTotalInfo.restaurant_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "lightblack-font"
  }, [(_vm.goodsTotalInfo.sort_method === '0') ? _c('span', [_vm._v("订货日期：")]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalInfo.sort_method === '1') ? _c('span', [_vm._v("到货日期：")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.store.goodsTotalInfo.start_date) + " 至 " + _vm._s(_vm.store.goodsTotalInfo.end_date) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodsTotalInfo.select_detail == 1),
      expression: "goodsTotalInfo.select_detail==1"
    }],
    staticClass: "goods-company-summary-right"
  }, [_c('div', {
    staticClass: "gd"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gord),
      expression: "gord"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gord) ? _vm._i(_vm.gord, null) > -1 : (_vm.gord)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gord,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gord = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gord = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gord = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('span', [_vm._v("区分门店")])]), _vm._v(" "), _c('div', {
    staticClass: "gd"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupByHouse),
      expression: "groupByHouse"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.groupByHouse) ? _vm._i(_vm.groupByHouse, null) > -1 : (_vm.groupByHouse)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.groupByHouse,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.groupByHouse = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.groupByHouse = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.groupByHouse = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('span', [_vm._v("区分仓库")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-float"
  }), _vm._v(" "), (_vm.goodsTotalInfo.select_detail == 0) ? _c('div', {
    staticClass: "goods-company-summary-wrapper"
  }, _vm._l((_vm.billCounts), function(billCount) {
    return _c('div', {
      staticClass: "goods-company-detail-list"
    }, [(billCount.bill_state === 10) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("未处理")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 11) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 12) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已发货")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 13) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已收货")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 14) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已收货 已确认")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 20) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("未确认")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 21) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已确认")]) : _vm._e(), _vm._v(" "), _c('strong', {
      staticClass: "goods-company-detail-name"
    }, [_vm._v(_vm._s(billCount.organName ? billCount.organName : billCount.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-company-detail-show",
      on: {
        "click": function($event) {
          return _vm.goodsInfo(_vm.organ_id, billCount, billCount.organName)
        }
      }
    }, [_c('ul', {
      staticClass: "goods-company-detail-show-ul"
    }, [(billCount.goods_code) ? _c('li', {
      staticClass: "detail-bill-fulllist",
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._v("品项编号：" + _vm._s(billCount.goods_code))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("订：\n\t\t\t\t\t\t\t\t"), (billCount.organName) ? [_c('span', {
      staticStyle: {
        "padding": "1px 0"
      }
    }, [_vm._v("明细")])] : _vm._e(), _vm._v("数\n\t\t\t\t\t\t\t\t"), (billCount.goods_name) ? [_vm._v("\n\t\t\t\t\t\t\t\t\t量\n\t\t\t\t\t\t\t\t")] : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(billCount.goods_num) + "\n\t\t\t\t\t\t\t")], 2), _vm._v(" "), _c('li', [_vm._v("含税金额：¥ " + _vm._s(billCount.sub_total))]), _vm._v(" "), (billCount.bill_state === 12 || billCount.bill_state === 13 || billCount.bill_state === 14) ? _c('li', [_vm._v("发：\n\t\t\t\t\t\t\t\t"), (billCount.organName) ? [_c('span', {
      staticStyle: {
        "padding": "1px 0"
      }
    }, [_vm._v("明细")])] : _vm._e(), _vm._v("数\n\t\t\t\t\t\t\t\t"), (billCount.goods_name) ? [_vm._v("\n\t\t\t\t\t\t\t\t\t量\n\t\t\t\t\t\t\t\t")] : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(billCount.goods_num_send) + "\n\t\t\t\t\t\t\t")], 2) : _vm._e(), _vm._v(" "), (billCount.bill_state === 12 || billCount.bill_state === 13 || billCount.bill_state === 14) ? _c('li', [_vm._v("含税金额：¥ " + _vm._s(billCount.sub_total_send))]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 13 || billCount.bill_state === 14) ? _c('li', [_vm._v("收：\n\t\t\t\t\t\t\t\t"), (billCount.organName) ? [_c('span', {
      staticStyle: {
        "padding": "1px 0"
      }
    }, [_vm._v("明细")])] : _vm._e(), _vm._v("数\n\t\t\t\t\t\t\t\t"), (billCount.goods_name) ? [_vm._v("\n\t\t\t\t\t\t\t\t\t量\n\t\t\t\t\t\t\t\t")] : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(billCount.goods_num_recipient) + "\n\t\t\t\t\t\t\t")], 2) : _vm._e(), _vm._v(" "), (billCount.bill_state === 13 || billCount.bill_state === 14) ? _c('li', [_vm._v("含税金额：¥ " + _vm._s(billCount.sub_total_recipient))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "clear-float"
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.goodsTotalInfo.select_detail == 1) ? _c('div', {
    staticClass: "goods-company-summary-wrapper"
  }, _vm._l((_vm.billCounts), function(billCount) {
    return _c('div', {
      staticClass: "goods-company-detail-list"
    }, [_c('div', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [(billCount.bill_state === 10) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("未处理")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 11) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 12) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已发货")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 13) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已收货")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 14) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已收货 已确认")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 20) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("未确认")]) : _vm._e(), _vm._v(" "), (billCount.bill_state === 21) ? _c('span', {
      staticClass: "goods-company-status"
    }, [_vm._v("已确认")]) : _vm._e(), _vm._v(" "), _c('strong', {
      staticClass: "goods-company-detail-name"
    }, [_vm._v(_vm._s(billCount.organName ? billCount.organName : billCount.goods_name))])]), _vm._v(" "), (_vm.groupByHouse) ? _c('div', {
      staticClass: "goods-company-house title-font"
    }, [_c('span', [_vm._v("收货仓库：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(billCount.storeName ? billCount.storeName : ''))])]) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "listContainerRef",
      refInFor: true,
      staticClass: "list-container"
    }, [_c('div', {
      staticClass: "list-content"
    }, [_c('div', {
      ref: "columnContainerRef",
      refInFor: true,
      staticClass: "list-head"
    }, [_c('div', {
      staticClass: "column-content"
    }, [_c('div', {
      staticClass: "fixed-column fx-ellipsis"
    }, [_vm._v("品项名称")]), _vm._v(" "), _c('div', {
      staticClass: "list-column fx-ellipsis"
    }, [_vm._v("订货数量")]), _vm._v(" "), _c('div', {
      staticClass: "list-column fx-ellipsis",
      staticStyle: {
        "width": "18vw"
      }
    }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.gord || _vm.groupByHouse),
        expression: "gord || groupByHouse"
      }],
      staticClass: "list-column fx-ellipsis"
    }, [_vm._v("明细备注")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.gord && !_vm.groupByHouse),
        expression: "gord && !groupByHouse"
      }],
      staticClass: "list-column fx-ellipsis"
    }, [_vm._v("辅助单位")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.gord && !_vm.groupByHouse),
        expression: "gord && !groupByHouse"
      }],
      staticClass: "list-column fx-ellipsis"
    }, [_vm._v("辅助数量")])])]), _vm._v(" "), _c('div', {
      staticClass: "list-body"
    }, [_c('div', {
      staticClass: "list-body-main"
    }, _vm._l((billCount.goods), function(good) {
      return _c('div', {
        staticClass: "item-list"
      }, [_c('div', {
        staticClass: "item-name"
      }, [_vm._v(_vm._s(good.goods_name))]), _vm._v(" "), _c('div', {
        staticClass: "item-info"
      }, [_vm._v(_vm._s(good.goods_num))]), _vm._v(" "), _c('div', {
        staticClass: "item-info",
        staticStyle: {
          "width": "18vw"
        }
      }, [_vm._v(_vm._s(good.goods_unit))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.gord || _vm.groupByHouse),
          expression: "gord || groupByHouse"
        }],
        staticClass: "item-info"
      }, [_vm._v(_vm._s(good.remark))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.gord && !_vm.groupByHouse),
          expression: "gord && !groupByHouse"
        }],
        staticClass: "item-info"
      }, [_vm._v(_vm._s(good.goods_assist_unit))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.gord && !_vm.groupByHouse),
          expression: "gord && !groupByHouse"
        }],
        staticClass: "item-info"
      }, [_vm._v(_vm._s(good.goods_assist_unit ? good.goods_assist_num : ''))])])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "list-bottom"
    }, [_c('div', {
      staticClass: "total-content"
    }, [_c('div', {
      staticClass: "list-column"
    }, [_vm._v("合计: " + _vm._s(_vm.getGoodsCount(billCount.goods)))])])])])])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    attrs: {
      "cls": _vm.cls,
      "font": _vm.font
    }
  }), _vm._v(" "), _c('mid-ware', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.midware),
      expression: "midware"
    }],
    attrs: {
      "icon": _vm.icon,
      "midFont": _vm.midFont
    }
  })], 1), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('get-total', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total),
      expression: "total"
    }],
    ref: "cTotal",
    attrs: {
      "filter": _vm.filterData,
      "href": "/cldEdi/business/getGoodsInfoReportTotal",
      "name": "餐企"
    }
  }), _vm._v(" "), _c('summary-filter', {
    ref: "summaryShow",
    on: {
      "searchPost": _vm.getSearchCondition
    }
  }), _vm._v(" "), _c('fx-share', {
    model: {
      value: (_vm.copyPopShow),
      callback: function($$v) {
        _vm.copyPopShow = $$v
      },
      expression: "copyPopShow"
    }
  }, [_c('template', {
    slot: "mainContent"
  }, _vm._l((_vm.billCounts), function(billCount) {
    return _c('div', {
      staticClass: "order-item-block"
    }, [_c('div', {
      staticClass: "title-name"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(!_vm.gord && !_vm.groupByHouse ? ("订货企业：" + (_vm.store.goodsTotalInfo.restaurant_name)) : '') + "\n\t\t\t\t\t" + _vm._s(billCount.organName ? ("订货机构：" + (billCount.organName)) : billCount.goods_name) + "\n\t\t\t\t\t" + _vm._s(_vm._f("dateFilterYMD")(billCount.to_date)) + "\n\t\t\t\t")]), _vm._v(" "), (_vm.groupByHouse) ? _c('div', {
      staticClass: "text-word"
    }, [_vm._v("收货仓库：" + _vm._s(billCount.storeName ? billCount.storeName : ''))]) : _vm._e(), _vm._v(" "), _vm._l((billCount.goods), function(good, index) {
      return _c('div', {
        staticClass: "item-row"
      }, [_c('div', {
        staticClass: "item-info"
      }, [_vm._v(_vm._s(index + 1) + "、" + _vm._s(good.goods_name) + "：" + _vm._s(good.goods_num) + _vm._s(good.goods_unit) + _vm._s(good.goods_assist_unit && _vm.gord && !_vm.groupByHouse ? ' 辅助：' + good.goods_assist_num + good.goods_assist_unit : ''))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (good.remark),
          expression: "good.remark"
        }],
        staticClass: "item-remark"
      }, [_vm._v("备注：" + _vm._s(good.remark))])])
    })], 2)
  }), 0)], 2), _vm._v(" "), (!_vm.midware && _vm.goodsTotalInfo.select_detail == 1) ? _c('side-float', {
    attrs: {
      "bottom": 40
    },
    on: {
      "on-click": function($event) {
        _vm.copyPopShow = !_vm.copyPopShow
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7985abda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GoodsCompanySummary.vue
// module id = 591
// module chunks = 1